import { lazy } from 'react';

import type { TabKenh } from '../channels/tabRegistry.js';

/** Mục "Nhạc" trong tab "Nội dung & nhạc" (order 50 theo docs/modules/_ban-do-phu-thuoc.md). */
const channelTabs: TabKenh[] = [
  {
    id: 'nhac',
    nhom: 'noi-dung-nhac',
    label: 'Nhạc kênh đang dùng',
    order: 50,
    permission: { module: 'music', level: 'view' },
    component: lazy(() => import('./components/TabNhacCuaKenh.js')),
  },
];

export default channelTabs;
